export enum CommerceTransactionsWorkspaceCapabilityAccessOperation {
    create = "88600448-2cc6-4591-b019-81288af60c90",
    read = "522953e7-e650-4400-a0c1-ebe2612c0105",
    update = "7a8346a7-bb6f-4ee5-bc6a-104177a09120",
    delete = "b8b92f7b-7c01-4e6b-ae23-4d287ebc15a6",
}
